import providerCatalog from '../providerCatalog';
import type { PlatformCostProviderId } from '../types';

const isPlatformCostProviderId = (value: string): value is PlatformCostProviderId =>
    Object.prototype.hasOwnProperty.call(providerCatalog, value);

export default isPlatformCostProviderId;
